import { useEffect, useState } from "react";

export default function useLocalStorage(key, initialValue) {
  // Pass initial state function to useState so logic is only executed once
  const [storedValue, setStoredValue] = useState(initialValue);

  const removeValue = (keyof) => {
    try {
      if (typeof window !== "undefined") {
        window.localStorage.removeItem(keyof);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const setValue = (value) => {
    try {
      const valueToStore =
        value instanceof Function ? value(storedValue) : value;
      setStoredValue(valueToStore);
      if (typeof window !== "undefined") {
        window.localStorage.setItem(key, JSON.stringify(valueToStore));
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    try {
      const item = window.localStorage.getItem(key);
      setStoredValue(item ? JSON.parse(item) : initialValue);
    } catch (error) {
      console.error(error);
      setStoredValue(initialValue);
    }
  }, []);

  useEffect(() => {
    const onStorageUpdate = (e) => {
      const { key: keyValue, newValue } = e;
      if (keyValue === key) {
        if (newValue) {
          setValue(JSON.parse(newValue));
        }
      }
    };

    window.addEventListener("storage", onStorageUpdate);
    return () => {
      window.removeEventListener("storage", onStorageUpdate);
    };
  }, [key]);

  return [storedValue, setValue, removeValue];
}
